import { useState, useEffect } from "react";

import { useLoadVariables as useLoadProjectVariables } from "Reducers/project/settings/variable/hooks/useLoadVariables";

import { useLoadVariables } from "./useLoadVariables";

export function useGetVariable({
  organizationId,
  projectId,
  variableId,
  environmentId
}: {
  organizationId: string;
  projectId: string;
  variableId: string;
  environmentId: string;
}) {
  const { variables: projectListVariables } = useLoadProjectVariables({
    organizationId,
    projectId
  });
  const { variables, getOrigin, isOverridingFrom, loading, errors, status } =
    useLoadVariables({
      organizationId,
      projectId,
      environmentId,
      projectListVariables
    });
  const [variable, setVariable] = useState(
    variables.find(variable => variable.id === variableId)
  );
  useEffect(() => {
    if (!variable) {
      setVariable(variables.find(variable => variable.id === variableId));
    }
  }, [variableId, variables, variable]);

  return {
    variable,
    setVariable,
    getOrigin,
    isOverridingFrom,
    loading,
    errors,
    status
  };
}
